const HERO_IMAGE = 'https://static.readdy.ai/image/68f89381c4c7240bb69246b185e50103/75af2e7887c699004e6c25eae6221f0c.png';

export default function HeroSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: '#1a1a1a' }}
      aria-label="メインビジュアル"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        role="img"
        aria-label="雪景色の中でタイヤと共に立つスタッフ"
      />

      {/* Dark overlay - gradient from top to bottom */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(26,26,26,0.45) 0%, rgba(26,26,26,0.6) 50%, rgba(26,26,26,0.85) 100%)',
        }}
      />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-12 py-32 flex flex-col items-start">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-4 py-2 rounded mb-6 text-sm font-medium tracking-widest uppercase"
          style={{
            backgroundColor: 'rgba(245,166,35,0.15)',
            border: '1px solid rgba(245,166,35,0.5)',
            color: '#f5a623',
            fontFamily: '"Oswald", sans-serif',
          }}
        >
          <i className="ri-map-pin-fill text-xs"></i>
          Tokyo Ome — Used Tire Specialist
        </div>

        {/* Main copy */}
        <h1
          className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-4 text-white"
          style={{ fontFamily: '"Noto Sans JP", sans-serif', letterSpacing: '-0.02em' }}
        >
          <span style={{ color: '#f5a623' }}>安心・格安</span>の中古タイヤ、<br />
          <span className="whitespace-nowrap">青梅から全力でお届け。</span>
        </h1>

        {/* Sub copy */}
        <p
          className="text-lg md:text-xl mb-10 font-medium"
          style={{ color: 'rgba(255,255,255,0.85)', fontFamily: '"Noto Sans JP", sans-serif' }}
        >
          baba Kaba｜東京都青梅市の中古タイヤ専門店
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="tel:08097798744"
            className="flex items-center justify-center gap-3 px-8 py-4 rounded font-bold text-lg whitespace-nowrap transition-all duration-200 hover:opacity-90 active:scale-95"
            style={{
              backgroundColor: '#f5a623',
              color: '#1a1a1a',
              fontFamily: '"Noto Sans JP", sans-serif',
            }}
          >
            <i className="ri-phone-fill text-xl"></i>
            電話でお問い合わせ
          </a>
          <button
            onClick={() => scrollTo('shop-info')}
            className="flex items-center justify-center gap-3 px-8 py-4 rounded font-bold text-lg whitespace-nowrap transition-all duration-200 cursor-pointer"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid rgba(255,255,255,0.8)',
              color: '#ffffff',
              fontFamily: '"Noto Sans JP", sans-serif',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLButtonElement).style.borderColor = '#f5a623';
              (e.currentTarget as HTMLButtonElement).style.color = '#f5a623';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLButtonElement).style.borderColor = 'rgba(255,255,255,0.8)';
              (e.currentTarget as HTMLButtonElement).style.color = '#ffffff';
            }}
          >
            <i className="ri-map-pin-line text-xl"></i>
            店舗情報を見る
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-xs tracking-widest uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontFamily: '"Oswald", sans-serif' }}>
            Scroll
          </span>
          <i className="ri-arrow-down-line text-xl" style={{ color: 'rgba(255,255,255,0.5)' }}></i>
        </div>
      </div>
    </section>
  );
}